import { render } from "./AddEditWebBotTemplateSettings.vue?vue&type=template&id=58700ac0&scoped=true"
import script from "./AddEditWebBotTemplateSettings.vue?vue&type=script&lang=js"
export * from "./AddEditWebBotTemplateSettings.vue?vue&type=script&lang=js"

import "./AddEditWebBotTemplateSettings.vue?vue&type=style&index=0&id=58700ac0&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58700ac0"]])

export default __exports__